import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/vi';
import 'dayjs/locale/en';

dayjs.extend(relativeTime);

/**
 * Hiển thị thời gian tương đối (từ …) theo ngôn ngữ UI.
 *
 * @param iso - Chuỗi thời gian parse được bởi `dayjs`.
 * @param locale - Mã ngôn ngữ i18n (ví dụ `vi`, `en`).
 */
export function formatHeaderNotificationTime(iso: string, locale: string): string {
  const d = dayjs(iso);
  if (!d.isValid()) return '';
  const lng = locale.toLowerCase().startsWith('vi') ? 'vi' : 'en';
  return d.locale(lng).fromNow();
}
